// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tab-btn-container-wrapper {
  position: relative;
  z-index: 1060;
  background-color: white;
  margin-top: -10px;
  margin-left: -20px;
  padding: 10px 20px 0px 20px;
  width: calc(100% + 40px);
}

.tab-btn-container {
  width: 100%;
  display: flex;
  border-bottom: 1px solid #b1bdc9;
  z-index: 1060;
  position: relative;
  background-color: white;
}

.tab-btn {
  width: 150px;
  background-color: #d6d6d6;
  font-weight: normal;
}

.tab-btn:hover {
  background-color: #ccd7e1;
}

.active-tab {
  width: 150px;
  border-bottom: 4px solid #29A1A3;
  background-color: #e4e4e4;
  font-weight: bold;
}

.tab-btn-txt {
  font-family: "HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue",
    Helvetica, Arial, "Lucida Grande", sans-serif;
  font-size: 14px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: center;
  color: #243547;
}

.annotation-section {
  /* border-bottom: 1px solid #b1bdc9; */
  box-shadow: inset 0 0 2px #b1bdc9;

}

.annotation-pane {
  margin: 10px;
  margin-bottom: 0px;
  /* height: 290px; */
  height: 235px;
  overflow: scroll;
}

.show-annotation {
  display: flex;
  flex-direction: column;
}

.hide-annotation {
  display: none;
}

.annotation-div img {
  display: block;
  max-width: 100%;
  margin-bottom: 20px;
  max-height: 120px;
}

.notation2 {
  max-height: 240px !important;
}

.notation3 {
  max-height: 360px !important;
}

.notation4 {
  max-height: 480px !important;
}

.notation5 {
  max-height: 600px !important;
}

.notation6 {
  max-height: 720px !important;
}

.notation7 {
  max-height: 840px !important;
}

.notation8 {
  max-height: 960px !important;
}

.highlight-annotation {
  visibility: visible;
  margin: 5px 10px 0px 10px;
  color: teal;
  font-size: 12px;
  width: 15px;
}

.hide-highlight-annotation {
  visibility: hidden;
  width: 15px;
  margin: 12px 10px 0px 10px;
}

.hide-annotation {
  display: none;
}

.annotation-div-container {
  display: inline-flex;
  color: #243547;
  width: 100%;
}

.annotation-div {
  padding: 10px;
  width: calc(100% - 35px);
}`, "",{"version":3,"sources":["webpack://./src/Components/AnnotationSection/AnnotationSection.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE;iDAC+C;EAC/C,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,iCAAiC;;AAEnC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,wBAAwB;AAC1B","sourcesContent":[".tab-btn-container-wrapper {\n  position: relative;\n  z-index: 1060;\n  background-color: white;\n  margin-top: -10px;\n  margin-left: -20px;\n  padding: 10px 20px 0px 20px;\n  width: calc(100% + 40px);\n}\n\n.tab-btn-container {\n  width: 100%;\n  display: flex;\n  border-bottom: 1px solid #b1bdc9;\n  z-index: 1060;\n  position: relative;\n  background-color: white;\n}\n\n.tab-btn {\n  width: 150px;\n  background-color: #d6d6d6;\n  font-weight: normal;\n}\n\n.tab-btn:hover {\n  background-color: #ccd7e1;\n}\n\n.active-tab {\n  width: 150px;\n  border-bottom: 4px solid #29A1A3;\n  background-color: #e4e4e4;\n  font-weight: bold;\n}\n\n.tab-btn-txt {\n  font-family: \"HelveticaNeue-Light\", \"Helvetica Neue Light\", \"Helvetica Neue\",\n    Helvetica, Arial, \"Lucida Grande\", sans-serif;\n  font-size: 14px;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1;\n  letter-spacing: normal;\n  text-align: center;\n  color: #243547;\n}\n\n.annotation-section {\n  /* border-bottom: 1px solid #b1bdc9; */\n  box-shadow: inset 0 0 2px #b1bdc9;\n\n}\n\n.annotation-pane {\n  margin: 10px;\n  margin-bottom: 0px;\n  /* height: 290px; */\n  height: 235px;\n  overflow: scroll;\n}\n\n.show-annotation {\n  display: flex;\n  flex-direction: column;\n}\n\n.hide-annotation {\n  display: none;\n}\n\n.annotation-div img {\n  display: block;\n  max-width: 100%;\n  margin-bottom: 20px;\n  max-height: 120px;\n}\n\n.notation2 {\n  max-height: 240px !important;\n}\n\n.notation3 {\n  max-height: 360px !important;\n}\n\n.notation4 {\n  max-height: 480px !important;\n}\n\n.notation5 {\n  max-height: 600px !important;\n}\n\n.notation6 {\n  max-height: 720px !important;\n}\n\n.notation7 {\n  max-height: 840px !important;\n}\n\n.notation8 {\n  max-height: 960px !important;\n}\n\n.highlight-annotation {\n  visibility: visible;\n  margin: 5px 10px 0px 10px;\n  color: teal;\n  font-size: 12px;\n  width: 15px;\n}\n\n.hide-highlight-annotation {\n  visibility: hidden;\n  width: 15px;\n  margin: 12px 10px 0px 10px;\n}\n\n.hide-annotation {\n  display: none;\n}\n\n.annotation-div-container {\n  display: inline-flex;\n  color: #243547;\n  width: 100%;\n}\n\n.annotation-div {\n  padding: 10px;\n  width: calc(100% - 35px);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
